import ImpersonationError from './components/ImpersonationError';

export default ImpersonationError;



// WEBPACK FOOTER //
// ./src/routes/ImpersonationError/index.js